var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.translate['maintenance_title'][_vm.lang])}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.translate['maintenance'][_vm.lang]))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cf593c5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Maintenance.vue
// module id = null
// module chunks = 